export function parseAnswer(json) {
  return {
    taskId: json.IdTask,
    formId: json.IdForm,
    projectId: json.IdProject,
    taskState: json.TaskState,
    json: JSON.parse(json?.JsonAnswer),
    columns: (json?.Columns || []).map((column) => ({
      name: column.Name,
      data: column.Data,
      type: column.Type,
    })),
  };
}
